<template>
    <v-container grid-list-sm text-xs-left>

        <v-layout row wrap pa-2 align-end>
            <v-flex xs12 py-2>
                <span class="display-2">Edit your startup information</span>
            </v-flex>
            <v-flex xs12 pb-4>
                <span class="headline">Here you can modify your startup details to <strong>NTT DATA Discovery</strong></span>
            </v-flex>
        </v-layout>

        <v-layout row wrap pa-2>
            <v-flex xs12>
                <v-container fluid ma-0 pa-0>
                    <v-img
                            width="100%"
                            height="400px"
                            :src="require('@/assets/img/innovation/cytonn-photography-GJao3ZTX9gU-unsplash.jpg')"
                    >
                    </v-img>
                </v-container>
            </v-flex>
        </v-layout>

        <v-layout row wrap pt-5>
            <v-flex xs12 py-3>
                <span class="headline strong">
                    NTT DATA Discovery sends personal tokens to the startups at startup registration time. You should have received this token via mail soon after completing the registration process.
                </span>
            </v-flex>
            <v-layout row wrap justify-center>
                <v-flex xs6>
                    <v-text-field box v-model="token" label="Token"></v-text-field>
                </v-flex>
            </v-layout>
            <v-flex xs12 py-3>
                <span class="headline strong">
                    After clicking on the "Send Update Request" button you will receive an email containing a link to follow in order to edit the details of the startup registered in the Discovery.
                </span>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
                <vue-recaptcha ref="recaptcha" sitekey="6LfZA3cqAAAAAM24XBOAwmmDmoLgPdpxDM_hZf6l" @verify="verify" @expired="onCaptchaExpired">
                    <div style="display: inline-block" id="html-element"></div>
                    <br>
                    <v-btn dark color="primary" @click="submitCaptcha" :dark="validCaptcha" :disabled="!validCaptcha">Send Update Request</v-btn>
                </vue-recaptcha>
            </v-flex>

            <v-flex xs12 py-5>
                <span class="headline">
                    The link you will receive is valid for 30 minutes from the moment you request it. When the link expires, it is necessary to repeat the update request.
                </span>
            </v-flex>

            <v-flex xs12 py-5>
                <span class="title">
                    If you have lost or forgotten your token <a href="mailto:nttdata.discovery@nttdata.com?subject=Token%20request">contact</a> the NTT DATA Discovery administrators.
                </span>
            </v-flex>
        </v-layout>


        <v-dialog v-model="tokenStatus" max-width="450">
            <v-card v-if="tokenError">
                <v-card-title class="headline error white--text">Process failed</v-card-title>
                <v-card-text>Your token is not valid!</v-card-text>
            </v-card>
            <v-card v-else>
                <v-card-title class="headline success white--text">Submission successfully completed</v-card-title>
                <v-card-text>You will receive an email with the link to follow as soon as possible!</v-card-text>
            </v-card>
        </v-dialog>


    </v-container>

</template>

<script>
    import UrlsService from "@/helpers/UrlsService.js";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import RouterService from "@/helpers/RouterService";
    import AlertService from "@/helpers/AlertService";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "StartupRequestModifcation",
        components: {VueRecaptcha},
        props: {},

        data() {
            return {
                tokenStatus:false,
                tokenError: false,
                token: "",
                validCaptcha: false,
                captchaToken: ""

            };
        },
        mounted() {
            let recaptchaScript = document.createElement('script');
            recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
            recaptchaScript.async = true;
            recaptchaScript.defer = true;
            document.head.appendChild(recaptchaScript)
        },
        methods: {
            verify(token) {
                this.captchaToken = token;
                this.validCaptcha = true;
            },

            onCaptchaExpired () {
                this.$refs.recaptcha.reset()
                this.validCaptcha = false;
            },
            submitCaptcha(){
                this.sendUpdateStartupProposal(this.captchaToken);
                this.validCaptcha = false;
                this.$refs.recaptcha.reset()
            },
            navigate(path) {
                RouterService.goTo(path);
            },
            sendUpdateStartupProposal(token){
                if(this.token === ""){
                    let alertOptions = {
                        type: "error",
                        message: "You have to insert a token!",
                    };
                    AlertService.createAlert(alertOptions);
                }
                else{
                    let requestUrl = {
                        url: UrlsService.startupModificationProposal,
                        timeout: TimeService.secondsToMillis(0),
                    };
                    let requestData = {
                        token: this.token,
                        captchaResponse: token
                    };
                    let requestObject = {
                        type: "public",
                        urlsInfo: requestUrl,
                        data: {
                            data: requestData,
                        },
                    };
                    let messages = {
                        title: "Startup update",
                        loading: "Waiting for update proposal submission...",
                        error: "Cannot send update proposal...",
                    };
                    let options = {
                        loadingType: "fullscreen",
                        timeout: TimeService.secondsToMillis(0),
                    };
                    APILoaderDecoratorService.setLoader(requestObject, messages, options)
                        .then(responseSuccess => {
                            let responseChallenge = responseSuccess;
                            if(responseChallenge === null){
                                this.tokenStatus = true;
                                this.tokenError = false;
                            }
                            else if(responseChallenge !== null && responseChallenge.response.status === 404){
                                this.tokenStatus = true;
                                this.tokenError = true;
                            }
                        });
                }
            }

        },
    };
</script>

<style lang="scss">
</style>
